const typography = {
  fontFamily: "Inter",
};

export default typography;
